module.exports = __webpack_public_path__ + "lazerImage.webp?71c70196096d92cc6b32d185a4e283d2";